const activityPhotos = [
  {
    subFolder: "Conference Photographs",
    subSubFolders: [
      {
        subSubFolder: "Conference Photographs",
        files: [
          "assets/photos/Gallary/Conference Photographs/Conf.P-01.JPG",
          "assets/photos/Gallary/Conference Photographs/Conf.P-02.JPG",
          "assets/photos/Gallary/Conference Photographs/Conf.P-03.JPG",
          "assets/photos/Gallary/Conference Photographs/Conf.P-04.JPG",
          "assets/photos/Gallary/Conference Photographs/Conf.P-05.JPG",
        ],
      },
    ],
  },
  {
    subFolder: "Convocation Photographs",
    subSubFolders: [
      {
        subSubFolder: "Convocation Photographs",
        files: [
          "assets/photos/Gallary/Convocation Photographs/Conv.P--02.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-01.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-03.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-04.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-05.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-06.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-07.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-08.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-09.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-10.JPG",
        ],
      },
    ],
  },
  {
    subFolder: "Entertainment Photographs",
    subSubFolders: [
      {
        subSubFolder: "Entertainment Photographs",
        files: [
          "assets/photos/Gallary/Entertainment Photographs/EP-01.JPG",
          "assets/photos/Gallary/Entertainment Photographs/EP-02.JPG",
          "assets/photos/Gallary/Entertainment Photographs/EP-03.JPG",
        ],
      },
    ],
  },
  {
    subFolder: "My Exhibited Art Photographs",
    subSubFolders: [
      {
        subSubFolder: "My Exhibited Art Photographs",
        files: [
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAP-01.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAP-02.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAP-03.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAP-04.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAP-05.jpg",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAT-01.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAT-02.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAT-03.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAT-04.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAT-05.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAT-06.jpg",
        ],
      },
    ],
  },
  {
    subFolder: "Rag Day Photographs",
    subSubFolders: [
      {
        subSubFolder: "Rag Day Photographs",
        files: [
          "assets/photos/Gallary/Rag Day Photographs/RDP-01.JPG",
          "assets/photos/Gallary/Rag Day Photographs/RDP-02.JPG",
          "assets/photos/Gallary/Rag Day Photographs/RDP-03.JPG",
          "assets/photos/Gallary/Rag Day Photographs/RDP-04.JPG",
          "assets/photos/Gallary/Rag Day Photographs/RDP-05.JPG",
          "assets/photos/Gallary/Rag Day Photographs/RDP-06.JPG",
          "assets/photos/Gallary/Rag Day Photographs/RDP-07.JPG",
          "assets/photos/Gallary/Rag Day Photographs/RDP-08.JPG",
        ],
      },
    ],
  },
];

const projectPhotos = [
  {
    subFolder: "Insect Pest Management Practices and Biosafety",
    subSubFolders: [
      {
        subSubFolder: "Insect Pest Management Practices and Biosafety",
        files: [
          "assets/photos/Project Work Photographs/Insect Pest Management Practices and Biosafety/Project-IPM-01.JPG",
          "assets/photos/Project Work Photographs/Insect Pest Management Practices and Biosafety/Project-IPM-02.JPG",
          "assets/photos/Project Work Photographs/Insect Pest Management Practices and Biosafety/Project-IPM-03.JPG",
          "assets/photos/Project Work Photographs/Insect Pest Management Practices and Biosafety/Project-IPM-04.JPG",
          "assets/photos/Project Work Photographs/Insect Pest Management Practices and Biosafety/Project-IPM-05.JPG",
          "assets/photos/Project Work Photographs/Insect Pest Management Practices and Biosafety/Project-IPM-06.JPG",
          "assets/photos/Project Work Photographs/Insect Pest Management Practices and Biosafety/Project-IPM-07.JPG",
          "assets/photos/Project Work Photographs/Insect Pest Management Practices and Biosafety/Project-IPM-08.JPG",
          "assets/photos/Project Work Photographs/Insect Pest Management Practices and Biosafety/Project-IPM-09.JPG",
          "assets/photos/Project Work Photographs/Insect Pest Management Practices and Biosafety/Project-IPM-10.JPG",
          "assets/photos/Project Work Photographs/Insect Pest Management Practices and Biosafety/Project-IPM-11.JPG",
        ],
      },
    ],
  },
  {
    subFolder: "Insect as a Food: Bangladesh Perspectives",
    subSubFolders: [
      {
        subSubFolder: "Edible Insect (Market, Collection, Consumption)",
        files: [
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Edible Insect (Market, Collection, Consumption)/EI-MCC-01.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Edible Insect (Market, Collection, Consumption)/EI-MCC-02.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Edible Insect (Market, Collection, Consumption)/EI-MCC-03.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Edible Insect (Market, Collection, Consumption)/EI-MCC-04.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Edible Insect (Market, Collection, Consumption)/EI-MCC-05.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Edible Insect (Market, Collection, Consumption)/EI-MCC-06.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Edible Insect (Market, Collection, Consumption)/EI-MCC-07.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Edible Insect (Market, Collection, Consumption)/EI-MCC-08.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Edible Insect (Market, Collection, Consumption)/EI-MCC-09.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Edible Insect (Market, Collection, Consumption)/EI-MCC-10.JPG",
        ],
      },
      {
        subSubFolder: "Survey-Chakma Photographs",
        files: [
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Chakma Photographs/S-CP-01.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Chakma Photographs/S-CP-02.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Chakma Photographs/S-CP-03.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Chakma Photographs/S-CP-04.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Chakma Photographs/S-CP-05.JPG",
        ],
      },
      {
        subSubFolder: "Survey-Garo Photographs",
        files: [
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Garo Photographs/S-GP-01.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Garo Photographs/S-GP-02.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Garo Photographs/S-GP-03.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Garo Photographs/S-GP-04.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Garo Photographs/S-GP-05.JPG",
        ],
      },
      {
        subSubFolder: "Survey-Marma Photographs",
        files: [
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Marma Photographs/S-Mar.P-01.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Marma Photographs/S-Mar.P-02.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Marma Photographs/S-Mar.P-03.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Marma Photographs/S-Mar.P-04.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Marma Photographs/S-Mar.P-05.JPG",
        ],
      },
      {
        subSubFolder: "Survey-Mro Photographs",
        files: [
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Mro Photographs/S-Mro.P-01.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Mro Photographs/S-Mro.P-02.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Mro Photographs/S-Mro.P-03.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Mro Photographs/S-Mro.P-04.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Mro Photographs/S-Mro.P-05.JPG",
        ],
      },
      {
        subSubFolder: "Survey-Tongchangya Photographs",
        files: [
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Tongchangya Photographs/S-Tong.P-01.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Tongchangya Photographs/S-Tong.P-02.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Tongchangya Photographs/S-Tong.P-03.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Tongchangya Photographs/S-Tong.P-04.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Tongchangya Photographs/S-Tong.P-05.JPG",
        ],
      },
      {
        subSubFolder: "Survey-Tripura Photographs",
        files: [
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Tripura Photographs/S-Trip.P-01.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Tripura Photographs/S-Trip.P-02.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Tripura Photographs/S-Trip.P-03.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Tripura Photographs/S-Trip.P-04.JPG",
          "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Survey-Tripura Photographs/S-Trip.P-05.JPG",
        ],
      },
    ],
  },
];

const programsSAUPS = [
  {
    subSubFolder:
      "SAUPS 1st National Photography Exhibition and Competition-2017",
    files: [
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-01.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-02.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-03.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-04.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-05.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-06.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-07.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-08.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-09.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-10.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-11.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-12.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-13.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-14.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-15.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-16.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-17.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-18.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-19.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SAUPS 1st National Photography Exhibition and Competition-2017/SAUPS-1st National-20.JPG",
    ],
  },
  {
    subSubFolder:
      "ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019",
    files: [
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019/SAUPS-2nd National-01.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019/SAUPS-2nd National-02.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019/SAUPS-2nd National-03.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019/SAUPS-2nd National-04.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019/SAUPS-2nd National-05.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019/SAUPS-2nd National-06.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019/SAUPS-2nd National-07.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019/SAUPS-2nd National-08.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019/SAUPS-2nd National-09.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019/SAUPS-2nd National-10.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019/SAUPS-2nd National-11.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019/SAUPS-2nd National-12.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019/SAUPS-2nd National-13.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019/SAUPS-2nd National-14.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019/SAUPS-2nd National-15.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019/SAUPS-2nd National-16.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019/SAUPS-2nd National-17.JPG",
    ],
  },
  {
    subSubFolder:
      "ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021",
    files: [
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-01.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-02.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-03.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-04.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-05.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-06.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-07.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-08.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-09.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-10.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-11.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-12.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-13.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-14.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-15.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-16.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-17.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-18.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-19.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-20.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-21.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-22.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-23.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-24.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-25.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-26.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-27.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-28.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-29.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021/SAUPS-3rd National-30.JPG",
    ],
  },
  {
    subSubFolder: "SET OUT-1",
    files: [
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-1/Set Out-1-01.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-1/Set Out-1-02.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-1/Set Out-1-03.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-1/Set Out-1-04.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-1/Set Out-1-05.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-1/Set Out-1-06.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-1/Set Out-1-07.JPG",
    ],
  },
  {
    subSubFolder: "SET OUT-2",
    files: [
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-2/SET OUT (2)-01.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-2/SET OUT (2)-02.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-2/SET OUT (2)-03.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-2/SET OUT (2)-04.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-2/SET OUT (2)-05.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-2/SET OUT (2)-06.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-2/SET OUT (2)-07.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-2/SET OUT (2)-08.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-2/SET OUT (2)-09.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-2/SET OUT (2)-10.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-2/SET OUT (2)-11.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-2/SET OUT (2)-12.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-2/SET OUT (2)-13.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-2/SET OUT (2)-14.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-2/SET OUT (2)-15.jpg",
    ],
  },
  {
    subSubFolder: "SET OUT-3",
    files: [
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-3/SET OUT (3)-01.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-3/SET OUT (3)-02.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-3/SET OUT (3)-03.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-3/SET OUT (3)-04.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-3/SET OUT (3)-05.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-3/SET OUT (3)-06.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-3/SET OUT (3)-07.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-3/SET OUT (3)-08.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-3/SET OUT (3)-09.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-3/SET OUT (3)-10.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-3/SET OUT (3)-11.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-3/SET OUT (3)-12.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-3/SET OUT (3)-13.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-3/SET OUT (3)-14.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/SET OUT-3/SET OUT (3)-15.jpg",
    ],
  },
  {
    subSubFolder: "Shadow on the Colors",
    files: [
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-01.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-02.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-03.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-04.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-05.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-06.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-07.jpg",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-01.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-02.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-03.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-04.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-05.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-06.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-07.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-08.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-09.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-10.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/SAUPS Program Photographs/Shadow on the Colors/Shadow on the Colors-11.JPG",
    ],
  },
];

const gallery = [
  {
    subFolder: "Conference Photographs",
    subSubFolders: [
      {
        subSubFolder: "Conference Photographs",
        files: [
          "assets/photos/Gallary/Conference Photographs/Conf.P-01.JPG",
          "assets/photos/Gallary/Conference Photographs/Conf.P-02.JPG",
          "assets/photos/Gallary/Conference Photographs/Conf.P-03.JPG",
          "assets/photos/Gallary/Conference Photographs/Conf.P-04.JPG",
          "assets/photos/Gallary/Conference Photographs/Conf.P-05.JPG",
        ],
      },
    ],
  },
  {
    subFolder: "Convocation Photographs",
    subSubFolders: [
      {
        subSubFolder: "Convocation Photographs",
        files: [
          "assets/photos/Gallary/Convocation Photographs/Conv.P--02.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-01.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-03.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-04.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-05.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-06.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-07.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-08.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-09.JPG",
          "assets/photos/Gallary/Convocation Photographs/Conv.P-10.JPG",
        ],
      },
    ],
  },

  {
    subFolder: "My Exhibited Art Photographs",
    subSubFolders: [
      {
        subSubFolder: "My Exhibited Art Photographs",
        files: [
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAP-01.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAP-02.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAP-03.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAP-04.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAP-05.jpg",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAT-01.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAT-02.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAT-03.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAT-04.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAT-05.JPG",
          "assets/photos/Gallary/My Exhibited Art Photographs/MEAT-06.jpg",
        ],
      },
    ],
  },
  {
    subFolder: "Rag Day Photographs",
    subSubFolders: [
      {
        subSubFolder: "Rag Day Photographs",
        files: [
          "assets/photos/Gallary/Rag Day Photographs/RDP-01.JPG",
          "assets/photos/Gallary/Rag Day Photographs/RDP-02.JPG",
          "assets/photos/Gallary/Rag Day Photographs/RDP-03.JPG",
          "assets/photos/Gallary/Rag Day Photographs/RDP-04.JPG",
          "assets/photos/Gallary/Rag Day Photographs/RDP-05.JPG",
          "assets/photos/Gallary/Rag Day Photographs/RDP-06.JPG",
          "assets/photos/Gallary/Rag Day Photographs/RDP-07.JPG",
          "assets/photos/Gallary/Rag Day Photographs/RDP-08.JPG",
        ],
      },
    ],
  },
  {
    subFolder: "Entertainment Photographs",
    subSubFolders: [
      {
        subSubFolder: "Entertainment Photographs",
        files: [
          "assets/photos/Gallary/Entertainment Photographs/EP-01.JPG",
          "assets/photos/Gallary/Entertainment Photographs/EP-02.JPG",
          "assets/photos/Gallary/Entertainment Photographs/EP-03.JPG",
        ],
      },
    ],
  },
];

const photography = [
  {
    subFolder: "Art Photographs",
    subSubFolders: [
      {
        subSubFolder: "Art Photographs",
        files: [
          "assets/photos/Art Photography/Art Photographs/AP-01.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-02.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-03.jpg",
          "assets/photos/Art Photography/Art Photographs/AP-04.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-05.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-06.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-07.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-08.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-09.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-10.jpg",
          "assets/photos/Art Photography/Art Photographs/AP-11.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-12.jpg",
          "assets/photos/Art Photography/Art Photographs/AP-13.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-14.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-15.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-16.jpg",
          "assets/photos/Art Photography/Art Photographs/AP-17.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-18.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-19.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-20.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-21.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-22.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-23.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-24.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-25.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-26.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-27.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-28.jpg",
          "assets/photos/Art Photography/Art Photographs/AP-29.jpg",
          "assets/photos/Art Photography/Art Photographs/AP-30.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-31.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-32.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-33.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-34.jpg",
          "assets/photos/Art Photography/Art Photographs/AP-35.jpg",
          "assets/photos/Art Photography/Art Photographs/AP-36.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-37.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-38.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-39.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-40.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-41.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-42.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-43.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-44.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-45.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-46.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-47.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-48.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-49.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-50.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-51.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-52.JPG",
          "assets/photos/Art Photography/Art Photographs/AP-53.jpg",
          "assets/photos/Art Photography/Art Photographs/AP-54.JPG",
        ],
      },
    ],
  },
  {
    subFolder: "Photo Story-(AAGOMONI-The Advent)",
    subSubFolders: [
      {
        subSubFolder: "Photo Story-(AAGOMONI-The Advent)",
        files: [
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-01.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-02.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-03.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-04.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-05.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-06.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-07.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-08.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-09.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-10.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-11.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-12.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-13.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-14.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-15.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-16.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-17.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-18.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-19.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-20.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-21.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-22.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-23.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-24.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-25.JPG",
          "assets/photos/Art Photography/Photo Story-(AAGOMONI-The Advent)/PS-26.JPG",
        ],
      },
    ],
  },
];

const culturalPrograms = [
  {
    subSubFolder: "Cultural Program Photographs",
    files: [
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/Cultural Program Photographs/OPP-01.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/Cultural Program Photographs/OPP-02.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/Cultural Program Photographs/OPP-03.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/Cultural Program Photographs/OPP-04.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/Cultural Program Photographs/OPP-05.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/Cultural Program Photographs/OPP-06.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/Cultural Program Photographs/OPP-07.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/Cultural Program Photographs/OPP-08.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/Cultural Program Photographs/OPP-09.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/Cultural Program Photographs/OPP-10.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/Cultural Program Photographs/OPP-11.JPG",
      "assets/photos/EXTRA-CURRICULAR ACTIVITIES/Cultural Program Photographs/OPP-12.JPG",
    ],
  },
];

const data = {
  name: "Saumik Dev",
  profession:
    "An Entomology major, passionate Researcher, avid Art Photographer, Musician and Art Enthusiast",
  multi_professions: "Photographer",
  about: [
    "Saumik Dev was born in Sreemangal, Sylhet, Bangladesh. Starting from Fall 2022 (August, 2022), he is going to pursue his Doctoral degree - PhD in Entomology (Specialization in Medical/Public Health Entomology on Infectious Diseases) in the Department of Entomology at Virginia Tech, USA (Officially known as Virginia Polytechnic Institute and State University, Blacksburg, Virginia, USA). His PhD research will be on the development of novel muscarinic acetylcholine receptor insecticides and synergists to control the malaria mosquito (Anopheles gambiae).",
    "Earlier, Mr. Dev worked as a “Research Associate” in the Department of Entomology, Sylhet Agricultural University, Sylhet, Bangladesh. Prior to that, he completed both his M.Sc. in Entomology and B.Sc. in Agriculture degrees from Sylhet Agricultural University, Sylhet, Bangladesh. While pursuing the undergraduate degree, he developed keen interest in Entomology (the study of insects) that strive him to be an Entomologist upon completing the MS graduate program.",
    "As a short term goal, Mr. Dev has a strong desire and determination to pursue Ph.D. in Entomology. He aspires to make some significant contribution in society by applying his knowledge and skills that he will be gaining during his PhD journey.",
    "Outside academic matters, Mr. Dev has a great passion for Art Photography. Whenever free, he loves to explore the colorful moments of life, making him inclined to portray the lifestyle of common people. His art photographs were showcased in some photography exhibitions, with some international and national awards as well.",
    "Mr. Dev also holds a fascination for music and musical instruments. He loves to play Tabla and Guitar. He believes in the mantra “Diversity” and thus wishes to enrich himself with these kinds of multifaceted activities.",
  ],
  bio: "A MULTIFACETED ENTITY STRIVING FOR EXCELLENCE THROUGH CREATIVITY TO DEFINE THYSELF!",
  birthday: "4th Nov, 1992",
  address:
    "17, Blue Eye Tower (F-2), Borobazar, Ambarkhana, Sylhet, Bangladesh",
  email: "devsaumik@gmail.com",
  phone: "+8801717794396",
  website: "http://devsaumik.com",
  age: "28",
  degree: "B.E. in Computer Engineering",
  major: "Computer Engineering",
  skill_intro: "skill_intro",
  resume_intro:
    "Resume Intro Innovative and deadline-driven Graphic Designer with 3+ years of experience designing and developing user-centered  digital/print marketing material from initial concept to final, polished deliverable.",
  education: [
    {
      degree: "Master of Science (M.Sc.) in Entomology",
      date: "February, 2019",
      varsity:
        "Department of Entomology, Sylhet Agricultural University, Bangladesh",

      about:
        "Thesis Title: Status of edible insects in some ethnic groups of Bangladesh",
      cgpa: " 3.82 out of 4.00 (WES, USA)",
    },
    {
      degree: "Bachelor of Science (B.Sc.) in Agriculture (Honours)",
      date: "December, 2016",
      varsity:
        "Faculty of Agriculture, Sylhet Agricultural University, Bangladesh",
      about: "",
      cgpa: " 3.55 out of 4.00 (WES, USA) ",
    },
  ],
  training_experiences: [
    {
      title: "Thesis & Technical Report Writing",
      institute:
        "Institutional Quality Assurance Cell (IQAC), Sylhet Agricultural University, Sylhet, Bangladesh",
      date: "April, 2018",
      time: "3 days",
    },
    {
      title: "Documentary Photography",
      institute: "Shahjalal University of Science and Technology, Bangladesh",
      date: "October, 2018",
      time: "3 days",
    },
    {
      title: "Basic and Advanced Photography Course",
      institute:
        "Sylhet Photoart Institute, Bangladesh (Mentored by Fakrul Islam)",
      date: "October, 2017",
      time: "6 months",
    },
  ],
  standard_scores: [
    {
      standard_name: "Graduate Record Examination (GRE) Revised General Test",
      date: "August 6, 2020",
      fields: [
        {
          name: "Total Score",
          score: "312",
        },
        {
          name: "Verbal Reasoning",
          score: "153",
        },
        {
          name: "Quantitative Reasoning",
          score: "159",
        },
        {
          name: "Analytical Writing Assessment (AWA)",
          score: "3.5",
        },
      ],
    },

    {
      standard_name:
        "International English Language Testing System (IELTS) Academic Test",
      date: "November 12, 2020",
      fields: [
        {
          name: "Overall Band Score",
          score: "7.5",
        },
        {
          name: "Listening",
          score: "7.5",
        },
        {
          name: "Reading",
          score: "7.5",
        },
        {
          name: "Writing",
          score: "7.0",
        },
        {
          name: "Speaking",
          score: "7.5",
        },
      ],
    },

    {
      standard_name: "Test of English as a Foreign Language (TOEFL) iBT Test",
      date: "May 22, 2021",
      fields: [
        {
          name: "Total Score",
          score: "103",
        },
        {
          name: "Reading",
          score: "25",
        },
        {
          name: "Listening",
          score: "24",
        },
        {
          name: "Speaking",
          score: "27",
        },
        {
          name: "Writing",
          score: "27",
        },
      ],
    },

    {
      standard_name: "Duolingo English Test (DET)",
      date: "June 23, 2022",
      fields: [
        {
          name: "Overall Score",
          score: "125",
        },
        {
          name: "Literacy",
          score: "130",
        },
        {
          name: "Comprehension",
          score: "125",
        },
        {
          name: "Conversation",
          score: "120",
        },
        {
          name: "Production",
          score: "120",
        },
      ],
    },
  ],

  professional_experiences: [
    {
      title: "Research Associate",
      date: "October, 2020-Present",
      institute: "",
      tasks: [
        "Project: Insect Pest Management Practices and Biosafety Status of Country Bean (Lablab purpureus L.) in Bangladesh” (BRBGP-2020-09).",
        "Approved by-Agriculture & Food System Institute (AFSI)",
        "Funded by-USAID",
      ],
    },
    {
      title: "Graduate Research Assistant",
      date: "July, 2017- December, 2018",
      institute: "",
      tasks: [
        "Project: Insect as a Food: Bangladesh Perspectives",
        "Funded by- University Grants Commission (UGC), Bangladesh.",
      ],
    },
  ],

  teaching_experiences: [
    {
      title: "Graduate Teaching Assistant",
      date: "July, 2017- December, 2018",
      institute:
        "Department of Entomology, Sylhet Agricultural University, Bangladesh",
      tasks: [],
    },
  ],

  organizational_experiences: [
    {
      program:
        "ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021",
      position: "Host / Convener",
      date: "2021",
    },
    {
      program:
        "Souvenir, ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021",
      position: "Editor-in-Chief",
      date: "2021",
    },
    {
      program:
        "ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019",
      position: "Host / Convener",
      date: "2019",
    },
    {
      program:
        "Souvenir, “ART OF LIGHT-SAUPS 2nd  National Photography Exhibition and Competition-2019”",
      position: "Editor-in-Chief",
      date: "2019",
    },
    {
      program:
        "Prize Giving Ceremony, “ART OF LIGHT-SAUPS 2nd  National Photography Exhibition and Competition-2019”",
      position: "Anchor",
      date: "2019",
    },
    {
      program: "“Photo Walk” in Sreemangal, Sylhet by SAUPS",
      position: "Host",
      date: "2019",
    },
    {
      program: "SAUPS 1st Photography Workshop",
      position: "Instructor",
      date: "2018",
    },
    {
      program: "SET OUT-2, Intra-University Photography Exhibition by SAUPS",
      position: "Host / Convener",
      date: "2018",
    },
    {
      program:
        "Oghraner Sougath, Cultural Program, Krishnachura Cultural Organization ",
      position: "Event Executive",
      date: "2018",
    },

    {
      program: "Cleaning Eco Park area, Sylhet by PRADHIKAR",
      position: "Volunteer",
      date: "2017",
    },
    {
      program: "SAUPS 1st National Photography Exhibition and Competition-2017",
      position: "Host/ Convener",
      date: "2017",
    },
    {
      program:
        "Souvenir, SAUPS 1st National Photography Exhibition and Competition-2017",
      position: "Editor-in-Chief",
      date: "2017",
    },
    {
      program:
        "Nobodhoni, Cultural Program, Krishnachura Cultural Organization",
      position: "Event Executive",
      date: "2017",
    },
    {
      program: "SET OUT-1, Intra-University Photography Exhibition by SAUPS",
      position: "Host/ Convener",
      date: "2016",
    },

    {
      program: "Agriculture Festival ",
      position: "Event Executive",
      date: "2016",
    },
  ],

  technical_skills: [
    {
      type: "Application Software",
      skills: "MS Word, MS Excel, MS PowerPoint",
    },
    {
      type: "Statistical Software",
      skills: "SPSS, R Software",
    },
    {
      type: "Image Processing Software",
      skills: "Adobe Photoshop, Adobe Illustrator",
    },
  ],

  leadership: [
    {
      position: "Founder and Chief Instructor",
      date: "2018- Present",
      institute: "SAUPS (Sylhet Agricultural University Photographic Society)",
    },
    {
      position: "Founding President",
      date: "2016- 2018",
      institute: "SAUPS (Sylhet Agricultural University Photographic Society)",
    },

    {
      position: "Vice President",
      date: "2017-2018",
      institute: "PRADHIKAR (An Environmental & Animal Welfare Organization)",
    },

    {
      position: "Publication Secretary",
      date: "2016-2018",
      institute:
        "Krishnachura Cultural Organization, Sylhet Agricultural University, Bangladesh",
    },
  ],

  activities: [
    {
      position: "Editor-in-Chief",
      description:
        "Souvenir of ‘ART OF LIGHT-SAUPS 3rd National Photography Exhibition and Competition-2021’",
    },
    {
      position: "Editor-in-Chief",
      description:
        "Souvenir of 'ART OF LIGHT-SAUPS 2nd National Photography Exhibition and Competition-2019'",
    },

    {
      position: "Editor-in-Chief",
      description:
        "Souvenir of “SAUPS 1st National Photography Exhibition and Competition-2017”",
    },
    {
      position: "Member of Volleyball Team",
      description:
        "(H.R.C. Hall, Sylhet Agricultural University) (Champion of 2013)",
    },
    {
      position: "Others",
      description:
        "Adept at Music (Singing), Playing musical instruments (Guitar and Tabla), Fine-art Photography",
    },
  ],
  journals: [
    {
      title: "Practices of entomophagy and entomotherapy in Bangladesh",

      proceeding: "Journal of Insects as Food and Feed 6(5): 515-524",

      authors:
        "Dev. S., Hassan, K., Claes, J., Mozahid, M.N., Khatun, H. and Mondal, M.F",
      link: "https://doi.org/10.3920/JIFF2020.0038",
      journal: "Q1 Journal",
      impact_factor: "Impact Factor: 5.099",
    },
  ],

  papers: [
    {
      title:
        "The minerals and pesticides residues of wild field cricket (Brachytrupes sp.) in Bangladesh",

      proceeding:
        "International Conference on Recent Advances in Chemistry (ICRAC 2020) (pp. 219-220)",

      authors:
        "Hasan, M. M., Hasan, M. M., S. Dev, M.A.S. Abir and Mondal, M.F.",
      venue: "Jagannath University, Dhaka, Bangladesh",
    },
    {
      title:
        "The value chain of fresh edible insect market in Bandarban, Bangladesh",

      proceeding:
        "Proceeding of International Conference on Sustainable Agriculture and Rural Development: Road to SDGs (pp. 52). Sylhet, Bangladesh",

      authors: "Faruque, M.O., Ahmed, T., Hasan, M.M., Dev, S. and Mondal M.F",
      venue:
        "Jointly organized by Bangladesh Agricultural Extension Society (BAES) and Sylhet Agricultural University, Bangladesh",
    },
    {
      title: "Survey on edible insects among some ethnic groups of Bangladesh",

      proceeding:
        "Proceedings of 3 rd CSD Annual Conference on Sustainable Development 2018 (pp. 30)",

      authors:
        "Mondal, M.F., Dev, S., Hassan, K., M.A.S. Abir and M. Kamrujjaman",
      venue: "University of Liberal Arts Bangladesh (ULAB), Dhaka, Bangladesh",
    },
  ],
  theses: [
    {
      title: "Status of edible insects in some ethnic groups of Bangladesh",
      supervisor:
        "Supervisor: Dr. Md. Fuad Mondal, Professor, Department of Entomology, Sylhet Agricultural University, Sylhet",
      detail: [
        "Information of 150 respondents from six ethnic groups were taken including perceptions and socio-economic factors regarding insects consumption",

        "Data of total 36 consumed insect species including medicinally used 9 species with their consumption characteristics were made",
        "7 top most constraints regarding entomophagy were identified",
      ],
    },
  ],
  memberships: [
    {
      institute:
        "General Member of Krishibid (Agriculturist) Institution Bangladesh (KIB)",
      memberId: "01-16-27143",
    },

    {
      institute: "General Member of Bangladesh Entomological Society (BES)",
      memberId: "01-16-27143",
    },
  ],
  researchInterest: [
    "Edible Insects",
    "Integrated Pest Management",
    "Insect Pathology",
    "Medical Entomology",
    "Insect Ecology and Evolution",
    "Apiculture",
    "Biological Control",
  ],
  culturalPrograms: culturalPrograms,
  activityPhotos: activityPhotos,
  programsSAUPS: programsSAUPS,
  gallery: gallery,
  photography: photography,
  projectPhotos: projectPhotos,
  projects: [
    {
      project: "Insect as a Food: Bangladesh Perspectives",
      defaultImage:
        "assets/photos/Project Work Photographs/Insect as a Food: Bangladesh Perspectives/Edible Insect (Market, Collection, Consumption)/EI-MCC-10.JPG",
      description:
        "This project documented aspects of entomophagy and entomotherapy of ethnic people in Bangladesh as this practice is believed to ensure future food security. A comprehensive survey was conducted involving six insect-consuming ethnic groups: Garo, Chakma, Tanchangya, Marma, Mro, and Tripura. Total data of 150 respondents were taken by selecting single member from each family, with a total of 25 families per ethnic groups. Data were analyzed by SPSS Statistical software. A total of 36 insect species of 19 families and 7 orders were consumed by them. In terms of species, those of the Coleoptera ranked highest (14), followed by Hymenoptera (7), Orthoptera (5), Hemiptera (5) and Blattodea (3 species); one species each belonged to Ephemeroptera and Odonata. The field cricket (Brachytrupes sp.), short-horned grasshopper (Oxya sp.) and giant water bug (Lethocerus indicus) were most preferred, reaching respective acceptance levels of 84, 83, and 79% by the respondents of all ethnic groups taken together. The total number of species used as human food by the Chakma, Marma, Mro, Tanchangya, Tripura, and Garo was 32, 22, 29, 21, 26, and 14, respectively. Nine species were used to treat coughs, fevers, nocturnal emissions, burning and gastroenteritis.",

      youtube:
        "https://www.youtube.com/watch?v=1FihCKG0RHo&list=PL-Ab1DY7nFK9Qhjb6SR4JwqiOyWjPOPQk",
    },
    {
      project: "Insect Pest Management Practices and Biosafety",
      defaultImage:
        "assets/photos/Project Work Photographs/Insect Pest Management Practices and Biosafety/Project-IPM-09.JPG",
      description:
        "This project is undertaken to create a platform for future assessment of the necessity for the development of ecosystem viable Genetically Engineered country bean plant through using the base line information. The specific objectives include determining the current insect pest status and management practices in country bean production system. Another important objective is to assess the biosafety situation in the country bean ecosystem. So far, we have collected basic information regarding the aforementioned details from 300 respondents across the selected areas throughout the country.",

      youtube: "",
    },
  ],
  achievements: [
    {
      title: '"National Science & Technology-(NST) Fellowship” for MS Research',
      issuedBy:
        "Ministry of Science and Technology, Government of the people's republic of Bangladesh",
      position: "",
      date: "2017",
      detail: "",
      image: "",
    },
    {
      title:
        "“Honorable Mention” Award (Lifestyle Photography Category) in BFPA International Photo Contest",
      issuedBy: "Bangladesh Freelance Photographer’s Association",
      position: "",
      date: "2017",
      detail: "",
      image: "",
    },
    {
      title:
        "2nd Prize (Camera Category) in Photography Exhibition and Competition “Photographic Communion”",
      issuedBy:
        "Leading University Photographic Society-(LUPS), Leading University, Bangladesh",
      position: "",
      date: "2018",
      detail: "",
      image: "",
    },
    {
      title: "1st Prize, Tabla Playing Competition (Secondary Category)",
      issuedBy: "Upazila Parishad, Sreemangal, Moulvibazar",
      position: "",
      date: "2008",
      detail: "",
      image: "",
    },
  ],
  facebook: "https://www.facebook.com/saumik.dev/",
  instagram: "https://www.instagram.com/saumik_dev/",
  linkedIn: "https://www.linkedin.com/in/saumik-dev-2b313b217/",
  twitter: "https://twitter.com/saumik_dev",
  skype: "",
  flickr: "https://www.flickr.com/photos/151807693@N04/",
  researchGate: "https://www.researchgate.net/profile/Saumik-Dev",
  googleScholar: "https://scholar.google.com/citations?hl=en&user=as6QYQ0AAAAJ",
  youTube: "https://www.youtube.com/channel/UCED60qcoBE9uEzay1kuPLLQ/featured",
};

export default data;
